module.exports = __webpack_public_path__ + "static/0088-7d96e7de6d2d64b8aea7b3ce9004fa15.png";